import { Signal as signal } from 'acast-www-utils';

export default signal();
